import React from 'react';
import clsx from 'clsx';
import ReactMarkdown from 'react-markdown';

export function transformLinkUri(uri) {
  if (typeof uri !== 'string') return '';

  const trimmed = uri.trim();
  if (!trimmed) {
    return '';
  }

  const normalized = trimmed.replace(/\s+/g, '');
  const lower = normalized.toLowerCase();

  if (lower.startsWith('#') || lower.startsWith('/')) {
    return normalized;
  }

  const schemeMatch = lower.match(/^([a-z][a-z0-9+.-]*):/);
  if (!schemeMatch) {
    return normalized;
  }

  if (!['http', 'https', 'mailto', 'tel'].includes(schemeMatch[1])) {
    return '';
  }

  return normalized;
}

export default function FormattedContent({ text, className, as: Component = 'div', ...rest }) {
  if (typeof text !== 'string') {
    return null;
  }

  const cleaned = text.trim();
  if (!cleaned) {
    return null;
  }

  return (
    <Component className={clsx('formatted-content', className)} {...rest}>
      <ReactMarkdown skipHtml transformLinkUri={transformLinkUri}>{cleaned}</ReactMarkdown>
    </Component>
  );
}
